<template>
  <Stat/>
</template>

<script>
import { mapGetters } from 'vuex';
import Stat from '@/layouts/Stat';

export default {
  name: 'statistic',
  components: {
    Stat,
  },
  computed: mapGetters({
    person: 'person',
  }),
  metaInfo() {
    return {
      title: this.title,
    };
  },
  data() {
    return {
      title: '',
    };
  },
  methods: {
    updateTitle() {
      this.title = this.person.first_name ? `${this.person.first_name} ${this.person.last_name}` : 'Вкусомер';
    },
  },
  watch: {
    person() {
      this.updateTitle();
    },
  },
  beforeDestory() {
    this.title = 'Вкусомер';
  },
};
</script>



// WEBPACK FOOTER //
// Statistic.vue?50303884